// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import LocationSchema from './location-schema';
import ProfessionsSchema from './professions-schema';

const schema = {
  $id: '/tdg-map-item-schema',
  type: 'object',
  required: ['id'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    location: {
      ...LocationSchema,
    },
    title: {
      type: 'string',
      nullable: true,
    },
    eventId: {
      type: 'integer',
      nullable: true,
    },
    eventName: {
      type: 'string',
      nullable: true,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    profession: {
      type: 'array',
      nullable: true,
      items: { ...ProfessionsSchema },
    },
  },
} as IJSONSchema;

export default schema;
